import { Legend } from "chart.js";

export const verticalChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false, // Başlığı gizle
        },
        title: {
            display: true,
            text: 'Autom Runtime',
            font: {
                size: 16, // Başlık boyutu
            },
            padding: {
                top: 10,
                bottom: 30,
            },
            color: '#1E88E5', // Başlık rengi
        },
        tooltip: {
            enabled: true,
            backgroundColor: '#FFF',
            borderColor: '#1E88E5',
            borderWidth: 1,
            titleColor: '#1E88E5',
            titleFont: {
                size: 14,
            },
            bodyColor: '#000',
            bodyFont: {
                size: 12,
            },
        },
    },
    scales: {
        x: {
            grid: {
                display: false, // X eksenindeki çizgileri gizle
            },
            ticks: {
                color: '#9E9E9E', // X ekseni etiket rengi
                font: {
                    size: 12,
                },
            },
        },
        y: {
            beginAtZero: true,
            grid: {
                color: '#E0E0E0', // Y ekseni çizgileri rengi
                drawBorder: false, // Y ekseni çerçevesini gizle
            },
            ticks: {
                color: '#9E9E9E', // Y ekseni etiket rengi
                font: {
                    size: 12,
                },
                stepSize: 2, // Y eksenindeki adım aralığı
            },
        },
    },
};

export const horizontalChartOptions = {
    indexAxis: 'y',  // Yatay grafiği etkinleştirir
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false,  // Legendi gizle
        },
        title: {
            display: true,
            text: 'Cumulative Revenue Savings',
            font: {
                size: 16,
            },
            color: '#37474F', // Başlık rengi
        },
    },
    scales: {
        x: {
            grid: {
                display: false, // X eksenindeki çizgileri gizle
            },
            ticks: {
                color: '#9E9E9E', // X ekseni etiket rengi
                font: {
                    size: 12,
                },
            },
        },
        y: {
            grid: {
                display: false, // Y eksenindeki çizgileri gizle
            },
            ticks: {
                color: '#9E9E9E', // Y ekseni etiket rengi
                font: {
                    size: 12,
                },
            },
        },
    },
};

export const heatMapChartOptions = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: true,
            text: 'Monthly Activity',
        },
        tooltip: {
            callbacks: {
                label: function (context) {
                    return `Week ${context.dataset.label}: ${context.raw}`;
                },
            },
        },
    },
    scales: {
        x: {
            stacked: true,
            grid: {
                display: false,
            },
        },
        y: {
            stacked: true,
            grid: {
                display: false,
            },
        },
    },
};

export const pieChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'bottom',
            labels: {
                font: (context) => {
                    const width = context.chart.height;
                    const size = Math.round(width / 18);
                    return {
                        size: size > 6 ? size : 6, // Minimum font size 10
                    };
                },
                boxWidth: 15, // Box genişliğini ayarlar
            },
        },
        title: {
            display: true,
            text: 'Pie Chart',
            font: {
                size: (context) => {
                    const width = context.chart.height;
                    const size = Math.round(width / 20);
                    return size > 12 ? size : 12; // Minimum font size 14
                },
            },
        },
    },
};

export const groupableVerticalChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
        legend: {
            position: 'top',
            // maxHeight: "50%", // Legend max yüksekliği
            // fullSize: false,
        },
        title: {
            display: true,
            text: 'Bar Chart (Data Visualization)',
        },

    },
    scales: {
        y: {
            beginAtZero: true,
            ticks: {
                callback: function (value) {
                    return `${value.toLocaleString()}`;
                }
            }
        },
    },
};

export const groupableHorizontalChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    indexAxis: 'y', // Yatay grafik için 'y' eksenini kullan
    plugins: {
        legend: {
            // position: 'top',
            // maxHeight: "50%", // Legend max yüksekliği
            fullSize: false,
        },
        title: {
            display: true,
            text: 'Horizontal Bar Chart (Data Visualization)',
        },

    },
    scales: {
        x: { // Yatay grafikte x ekseni, yatay olan eksendir
            beginAtZero: true,
            ticks: {
                callback: function (value) {
                    return `${value.toLocaleString()}`;
                }
            }
        },
    },
};

export const stringChartOptions = {
    container: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: 'transparent',
        padding: '10px',
        textAlign: 'center',
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
    },
    stringText: {
        // flexGrow: 1,
        // fontSize: '1vh',
        // fontSize: 'clamp(1rem, 1vh, 2rem)',
        fontWeight: 'bold',
        color: '#4F6E90',
        // maxWidth: "80%",
        overflow: "visible",
        textOverflow: "ellipsis",
        // marginBottom: '1%',
    },
    valueContainer: {
        display: 'flex',
        // alignItems: 'end',
        alignItems: 'center',
        justifyContent: 'center',
        // fontSize: '6vh',
        // fontSize: 'clamp(2rem, 8vh, 12rem)',
        fontWeight: 'bold',
        color: '#D4A055',
        userSelect: "text",
        width: "100%",
        height: "100%",
    },
    currencySymbol: {
        // fontSize: '36px',
        marginRight: '8px',
    },
    changeText: {
        // marginTop: '1%',
        // fontSize: '1.1vh',
        // fontSize: 'clamp(0.4rem, 1vh, 1rem)',
        color: '#3b873e',
        backgroundColor: '#d6f5d6',
        padding: '5px 10px',
        borderRadius: '5px',
        width: "fit-content"
    },
    percentageChange: {
        fontWeight: 'bold',
        // fontSize: '1.1vh',
        // fontSize: 'clamp(0.4rem, 1vh, 1rem)',
    },
};
